import {AppState} from '../app.model';
import {Injectable} from '@angular/core';
import {
    obiektListDeleteStoredStateByType,
    obiektListFilterCreateComplete,
    obiektListFilterCreateStart,
    obiektListFilterEditComplete,
    obiektListFilterEditStart,
    obiektListGetFilter,
    obiektListGetLockData,
    obiektListOpenAndSetUnappliedFilter,
    obiektListOpenAndSetUnappliedFilterComplete,
    obiektListResetStateByType,
    obiektListRestoreStateByType,
    obiektListSetCurrentFilter,
    obiektListSetDefaultStateByTypeComplete,
    obiektListSetDefaultStateByTypeStart, obiektListUpdateLockData
} from './obiekt-list.actions';
import {CreateFilterArgsDto} from '../../../common/model/WK.Ladon.Cms.Api.Model.Args.Filter.CreateFilterArgsDto';
import {FilterService, NotificationService} from '../../services';
import {EditFilterArgsDto} from '../../../common/model/WK.Ladon.Cms.Api.Model.Args.Filter.EditFilterArgsDto';
import {Data} from '../../../common/model/WK.Ladon.Cms.Read.Queries.Filters.Model.Data';
import {ErrorMessageResult} from '../../../common/model/WK.Ladon.Cms.Common.Model.Middleware.ErrorMessageResult';
import {select, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ListDefinitionsActionsService} from '../list-definitions/list-definitions.actions.service';
import {ListDefinitionTypePipe} from '../../../ladon-api-enums/WK.Ladon.Cms.Common.Model.Enum.ListDefinitionType';
import {metadataPreviewInitialize} from './metadata-preview/metadata-preview.actions';
import {catchError, map, mapTo, mergeMap, tap, withLatestFrom, first} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {LockService} from '../../../shared/services';

@Injectable()
export class ObiektListEffects {

    public getLockData$ = createEffect(() => this.actions$.pipe(
        ofType(obiektListGetLockData),
        withLatestFrom(this.store),
        mergeMap(([action, store]) => {
                const listDefinitionType = store.obiektList.listDefinitionType;
                const listDefinition = store.listDefinitions.definitionsByType[listDefinitionType];
                if (listDefinition) {
                    const listAggregateRootObiektType = listDefinition.aggregateRootObiektType;
                    if (action.obiektType === listAggregateRootObiektType) {
                        return this.lockService.getLockData(action.obiektId).pipe(
                            map(obiektLocksData => obiektListUpdateLockData({obiektLocksData: obiektLocksData}))
                        );
                    }
                }
                return EMPTY;
            }
        )));

    public createFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListFilterCreateStart),
            withLatestFrom(this.store),
            mergeMap(([action, store]) => {
                const newFilter: CreateFilterArgsDto = {
                    name: action.name,
                    listDefinitionType: store.obiektList.listDefinitionType,
                    data: store.obiektList.currentList.data as Data
                };
                return this.filterService.create(newFilter)
                    .pipe(tap(() => this.notificationService.success('Zapisano')),
                        catchError((error: HttpErrorResponse) => {
                            const body = error.error as ErrorMessageResult; // TODO: to się wywala jak w odpowiedzi nie ma jsona, do poprawienia wszędzie
                            this.notificationService.error(body.message);
                            return EMPTY;
                        }),
                        map(id => obiektListFilterCreateComplete({
                            filterId: id,
                            filterName: action.name,
                            filterOwnerUserId: action.ownerUserId
                        })));
            })));

    public editFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListFilterEditStart),
            withLatestFrom(this.store),
            mergeMap(([action, store]) => {
                const args: EditFilterArgsDto = {
                    name: store.obiektList.currentList.filterName,
                    data: store.obiektList.currentList.data as Data
                };

                return this.filterService.edit(action.id, args)
                    .pipe(tap(() => this.notificationService.success('Zapisano')),
                        catchError((error) => {
                            const body = error.error as ErrorMessageResult;
                            this.notificationService.error(body.message);
                            return EMPTY;
                        }),
                        mapTo(obiektListFilterEditComplete()));
            })));

    public getFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListGetFilter),
            mergeMap(action => this.filterService.get(action.id)),
            withLatestFrom(this.store),
            mergeMap(([filter, store]) => {
                // filter jest typu Readonly<Filter>, a nie FilterStore
                const listDefinition = store.listDefinitions.definitionsByType[filter.listDefinitionType];
                // jak w storze nie ma jeszcze definicji danej listy
                if (!listDefinition) {
                    this.listDefinitionsActionsService.loadListDefinition(filter.listDefinitionType);
                }

                return this.store
                    .pipe(select(state => {
                            return state.listDefinitions.definitionsByType[filter.listDefinitionType];
                        }),
                        first(definition => definition !== undefined),
                        map(definiton => {
                            return obiektListSetCurrentFilter({filter});
                        }));
            })));

    public setDefaultFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListSetDefaultStateByTypeStart),
            withLatestFrom(this.store),
            mergeMap(([action, store]) => {
                const listDefinitionType = action.listDefinitionType;
                // sprawdzanie czy mamy zapamiętany stan dla wskazanego typu listy
                const storedStateByType = store.obiektList.stateByType[listDefinitionType];
                if (storedStateByType !== undefined && storedStateByType !== null) {
                    // restore
                    return of(obiektListRestoreStateByType({
                        listDefinitionType,
                        readonlyFilterDataValues: action.readonlyFilterDataValues,
                        filterDataValues: action.filterDataValues
                    }));
                }

                const listDefinition = store.listDefinitions.definitionsByType[listDefinitionType];
                if (!listDefinition) {
                    this.listDefinitionsActionsService.loadListDefinition(listDefinitionType);
                }

                return this.store
                    .select(state => state.listDefinitions.definitionsByType[listDefinitionType])
                    .pipe(first(definition => definition !== undefined),
                        map(definiton => {
                                return obiektListSetDefaultStateByTypeComplete({
                                        listDefinitionType,
                                        listDefinition: definiton,
                                        readonlyFilterDataValues: action.readonlyFilterDataValues,
                                        filterDataValues: action.filterDataValues === undefined ? [] : action.filterDataValues
                                    }
                                )
                            }
                        ));
            })));

    public openAndSetUnappliedFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListOpenAndSetUnappliedFilter),
            withLatestFrom(this.store),
            map(([action, store]) => {
                const filterType = action.value.metadataId;
                // sklejanie nazwy np. PismoUrzedowe_ActulFilter
                const filterId = ListDefinitionTypePipe.enumDescriptionMap.get(store.obiektList.listDefinitionType) + '_' + filterType;

                return obiektListOpenAndSetUnappliedFilterComplete({
                    value: {
                        metadataId: filterId,
                        value: action.value.value
                    }
                });
            })));

    public resetCurrentState$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListResetStateByType),
            withLatestFrom(this.store),
            mergeMap(([action, store]) => {

                const listDefinitionType = action.listDefinitionType;
                // jak wskazano typ aktualnie wybranej listy to ustawiamy domyślny stan
                if (listDefinitionType === store.obiektList.listDefinitionType) {
                    // const listDefinition = store.listDefinitions.definitionsByType[ listDefinitionType ];

                    // if (!listDefinition) {
                    //     this.listDefinitionsActionsService.loadListDefinition(listDefinitionType);
                    // }
                    return this.store
                        .select(state => state.listDefinitions.definitionsByType[listDefinitionType])
                        .pipe(first(definition => definition !== undefined),
                            map(definiton => {
                                return obiektListSetDefaultStateByTypeComplete({
                                    listDefinitionType,
                                    listDefinition: definiton
                                });
                            }));
                }

                // jak typ jest inny to czyścimy zapamiętany stan
                return of(obiektListDeleteStoredStateByType({listDefinitionType}));
            })));

    // ładowanie definicji wskazanej listy po resecie
    public initializePreviewPanelsAfterSetDefaultFilter$ = createEffect(() => this.actions$
        .pipe(ofType(obiektListSetDefaultStateByTypeComplete),
            withLatestFrom(this.store),
            map(([action, store]) => {
                const listDefinitionType = action.listDefinitionType;
                const listDefinition = store.listDefinitions.definitionsByType[listDefinitionType];

                // return Observable.of(this.metadataPreviewActionsService.initialize(listDefinition));
                if (store.obiektList.currentList.data.listData.metadataPreview.panels.length === 0) {
                    return metadataPreviewInitialize({
                        metadataPanelDefinitions: listDefinition.metadataPanelDefinitions
                    });
                }
            })));

    constructor(private filterService: FilterService,
                private readonly lockService: LockService,
                private actions$: Actions,
                private store: Store<AppState>,
                private notificationService: NotificationService,
                private listDefinitionsActionsService: ListDefinitionsActionsService) {
    }

}

